export enum COOKIE_NAMES {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  REPORT_ABUSE = 'report_abuse',
  REDIRECT_TO_PATH = 'redirect_to',
}

export const SORT_DIR = {
  ASC: 'asc',
  DESC: 'desc',
};

export enum POPUP_FLAG {
  EXAMPLE = 'examplePopup',
  VIDEO = 'videoPopup',
  INSTRUCTION = 'instructionPopup',
  RESOURCES = 'resourcesPopup',
  NOTE = 'noteSidePane',
}

export enum ROLES {
  ADMIN = 'admin',
  USER = 'user',
  SUPER_ADMIN = 'super_admin',
  GUEST = 'guest',
  LEARNER = 'learner',
  OWNER = 'owner',
  INSTRUCTOR = 'instructor',
  ACCESS_APPROVED = 'access_approved',
  TESTER = 'tester',
  EXPERT = 'expert',
}

export enum PAGE_ELEMENT {
  ADD_ENTRY = 'add_entry',
  AI_RESPONSE = 'ai_response',
  AUDIO = 'audio',
  AUTO_DRAW = 'autodraw',
  BUSINESS_MODEL_CANVAS = 'business_model_canvas',
  BUTTON = 'button',
  CANVAS = 'canvas',
  CARD = 'card',
  CARD_FEEDBACK = 'card_feedback',
  CARD_FINAL_FEEDBACK = 'card_final_feedback',
  CARD_FINAL_REVIEW = 'card_final_review',
  CARD_REVIEW = 'card_review',
  CHAT_ACTIVITY = 'chat_activity',
  CHECKBOX = 'checkbox',
  COLUMN_TEXTAREA = 'column_textarea',
  CUSTOMER_JOURNEY_MAP = 'customer_journey_map',
  DOWNLOAD_FILE = 'download_file',
  DROPDOWN = 'dropdown',
  EMAIL_ACTIVITY = 'email_activity',
  ESSAY = 'essay',
  ESSAY_COPILOT = 'essay_copilot',
  EXAMPLE = 'example',
  EXECUTIVE_SUMMARY = 'executive_canvas_creator',
  FILL = 'fill',
  FINAL_CARD = 'final_card',
  FINAL_FEEDBACK = 'final_feedback',
  FINAL_REVIEW = 'final_review',
  FIVE_WHYS = 'five_whys',
  HMW_RANDOM = 'hmw_random',
  IDEA_CARD = 'idea_card',
  IMAGE = 'image',
  IMAGE_CHECKBOX = 'image_checkbox',
  IMAGE_MESSAGE = 'image_message',
  IMAGE_RADIO = 'image_radio',
  IMAGE_URL = 'image_url',
  INPUT = 'input',
  INPUT_LIST = 'input_list',
  MARVEL_IFRAME = 'marvel_iframe',
  MESSAGE = 'message',
  MESSAGE_REVIEW = 'message_review',
  NULL = '',
  OTHERS = 'others',
  PERSONA_ENTRY = 'persona_entry',
  POSTIT = 'postit',
  POSTIT_CHECKBOX = 'postit_checkbox',
  PRIORITIZATION_MATRIX = 'prioritization_matrix',
  RADIO = 'radio',
  SPACING = 'spacing',
  SUBMISSION_CARD = 'submission_card',
  TEXTAREA = 'textarea',
  UPLOAD_FILE = 'upload_file',
  UPLOAD_IMAGE = 'upload_image',
  USER_SELECT = 'user_select',
  VIDEO = 'video',
}

const ROOT_PATH = '/workspaces';

export const DEFAULT_PATH = ROOT_PATH;

export const PROJECTS_PATH = '/';

export const TITLE = 'Cartedo';

export const TEXTAREA_MAX_LENGTH = 100;

export const EMAIL_SUFFIX = '@tamu.edu';

export const CARTEDO_LINKS = {
  PRIVACY_POLICY: 'https://www.cartedo.com/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://www.cartedo.com/terms-condition',
  CONTACT_US: 'https://cartedo.com/contact-us',
  ABOUT_US: 'https://cartedo.com/about-us',
  FAQ: 'https://cartedo.com/faq',
  BLOG: 'https://cartedo.com/blog',
  HELP: 'https://cartedo.com/help',
  SUPPORT: 'https://cartedo.com/support',
  CAREERS: 'https://cartedo.com/careers',
  PRESS: 'https://cartedo.com/press',
  PARTNERS: 'https://cartedo.com/partners',
  WEBSITE: 'https://cartedo.com',
  GET_HELP: 'mailto:support@cartedo.com',
};

export const GLOBAL_MAX_WORD_LIMIT = 30000;

export const NOTIFICATION_AUDIO_URL =
  'https://res.cloudinary.com/ctdo-production/video/upload/v1762262332/audio/04c8cf25969b02577edd_hnhs0o.mp3';
